<template>
  <van-action-sheet v-model="isOpen" title="请选择你的学员分组" @close="handlerClose">
    <div class="content" :style="isPhone ? 'padding-bottom: 40px;': ''" v-if="groups.length">
      <div class="group-sheet">
        <div class="group-item" v-for="(item, index) in groups" :key="index" @click="handlerSelect(index)">
          <div
            class="group-item-text"
            :class="{ 'active-text': checkedIndex === index }"
          >
            {{ item.name }}
          </div>
          <img
            src="@/assets/clock/com_icon_choice_de.png"
            alt="select"
            class="group-item-icon"
            v-if="checkedIndex !== index"
          />
          <img
            src="@/assets/clock/com_icon_choice1.png"
            alt="select"
            class="group-item-icon"
            v-if="checkedIndex === index"
          />
        </div>
      </div>

      <div class="btm-btn" :class="{'active-btn': checkedIndex !== -1}" @click="handlerClick">立即进入</div>
    </div>
  </van-action-sheet>
</template>

<script>
import { ActionSheet } from 'vant';
import { ref, watch } from '@vue/composition-api';
import { setClassGroup } from '@/api/clockin';
import { isIos } from '@/common/js/utils';

export default {
  components: {
    [ActionSheet.name]: ActionSheet,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    groups: {
      type: Array,
      default() {
        return [];
      }
    },
    idObj: {
      type: Object,
      default() {
        return {
          detailId: 0,
          classId: 0
        };
      }
    }
  },
  setup(props, { emit }) {
    const isOpen = ref(false);

    watch(() => props.show, (val) => {
      if (val !== isOpen.value) {
        isOpen.value = val;
      }
    }, { immediate: true });

    watch(isOpen, (val) => {
      if (props.show !== val) {
        emit('update:show', val);
      }
    });


    const checkedIndex = ref(-1);

    const handlerSelect = (index) => {
      checkedIndex.value = index;
    };

    const handlerClick = () => {
      if (checkedIndex.value === -1) {
        return;
      }

      const data = { group_id: props.groups[checkedIndex.value].id };

      if (props.idObj.detailId) {
        data.detail_id = props.idObj.detailId;
      }

      if (props.idObj.classId) {
        data.class_id = props.idObj.classId;
      }

      setClassGroup(data).then((res) => {
        if (res.success) {
          emit('success', props.groups[checkedIndex.value].id);
        }
      });
    };

    const handlerClose = () => {
      emit('update:show', false);
    };

    const isPhone = isIos();

    return {
      isOpen,
      checkedIndex,
      handlerSelect,
      handlerClick,
      handlerClose,
      isPhone
    };
  },
};
</script>

<style lang="stylus" scoped>
.content {
  padding: 16px;

  .group-sheet {
    overflow-y auto
    min-height 256px
    max-height 390px
  }

  .group-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 0 16px;
    height: 56px;
    background: #f6f7fa;
    border-radius: 4px;

    .group-item-text {
      flex: 1;
      font-size: 16px;
      color: #191919;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .active-text {
      color: #ff9645;
    }

    .group-item-icon {
      margin-left: 16px;
      width: 16px;
      height: 16px;
    }
  }

  .btm-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin 5px 0
    height: 40px;
    background: #e7e7e7;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }

  .active-btn {
    background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
  }
}
</style>
